<div class="dialog-wrap">
  <p>{{"COMMENTS_MODAL.CONFIRM_DELETE" | translate}}</p>
  <div class="dialog-actions">
    <button mat-raised-button color="primary" (click)="confirm()">{{'REGISTER_DEVICE.CONFIRM' | translate}}</button>
    <button mat-raised-button color="warn" (click)="cancel()">{{'GENIUS_SETTINGS.CANCEL_BIND' | translate}}</button>
  </div>
</div>
